import { createSelector } from 'reselect';

// The button state (email presence) is now handled locally by the form's internal state.

const getIsIncorrectEmailMessageVisible = state =>
  state.auth.isIncorrectEmailMessageVisible;

const getIsSuccessMessageVisible = state =>
  state.auth.isForgotPasswordSuccessMessageVisible;

const getIsLoading = state => state.auth.isFetching;

/**
 * 2. Modernized Selector
 * This now only tracks API/Auth state. 
 * 'isButtonDisabled' is removed from this object as it's no longer global state.
 */
const getForgotPassword = createSelector(
  getIsLoading,
  getIsIncorrectEmailMessageVisible,
  getIsSuccessMessageVisible,
  (
    isLoading,
    isIncorrectEmailMessageVisible,
    isSuccessMessageVisible
  ) => ({
    isLoading,
    isIncorrectEmailMessageVisible,
    isSuccessMessageVisible
  })
);

export { getForgotPassword };
